import React, { useEffect, useState } from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import "./ValidationMessage.scss"

export const messageTypes = ["note", "error", "warning", "non-site"]
const ValidationMessage = ({ type = "note", value, tooltip }) => {
  const iconClassName = React.useMemo(() => {
    const classNames = []
    let iconCl = "fas fa-info-circle"
    let colorCl = "--error-validation"

    switch (type) {
      case "note":
        iconCl = "fas fa-info-circle"
        colorCl = "--note-validation"
        break
      case "error":
        iconCl = "fas fa-do-not-enter"
        colorCl = "--error-validation"
        break
      case "warning":
        iconCl = "fas fa-exclamation-triangle"
        colorCl = "--warning-validation"
        break
      case "non-site":
        iconCl = "fas fa-times-circle"
        colorCl = "--error-validation"
        break
      default:
        iconCl = "fas fa-info-circle"
        colorCl = "--note-validation"
        break
    }
    classNames.push(iconCl)
    classNames.push(colorCl)
    return classNames
  }, [type])

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <div className="validation-message-container">
          <i className={iconClassName.join(" ")} />
          {value}
        </div>
      </Tooltip>
    )
  }

  return (
    <div className="validation-message-container">
      <i className={iconClassName.join(" ")} />
      {value}
    </div>
  )
}

ValidationMessage.propTypes = {
  type: PropTypes.oneOf(messageTypes),
  source: PropTypes.string,
  value: PropTypes.string,
}

export default ValidationMessage
